var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWww = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 17.044,
    height: 11.651,
    viewBox: "0 0 17.044 11.651",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.546,136H22.5a1.5,1.5,0,0,0-1.5,1.5v8.655a1.5,1.5,0,0,0,1.5,1.5H36.546a1.5,1.5,0,0,0,1.5-1.5V137.5A1.5,1.5,0,0,0,36.546,136Zm.5,10.153a.5.5,0,0,1-.5.5H22.5a.5.5,0,0,1-.5-.5V137.5a.5.5,0,0,1,.5-.5H36.546a.5.5,0,0,1,.5.5Z",
    transform: "translate(-21 -136)",
    fill: "#324655"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 4.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.457,156.439a.309.309,0,0,0,.258-.218l.711-2.373a.309.309,0,1,0-.592-.177l-.51,1.7-.491-.82a.309.309,0,0,0-.53,0l-.491.82-.51-1.7a.309.309,0,1,0-.592.177l.711,2.373a.309.309,0,0,0,.258.218l.038,0a.309.309,0,0,0,.265-.15l.586-.979.586.979a.309.309,0,0,0,.3.148Z",
    transform: "translate(-81.695 -153.451)",
    fill: "#324655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.517,156.432l.038,0a.309.309,0,0,0,.265-.15l.586-.979.586.979a.309.309,0,0,0,.561-.07l.711-2.373a.309.309,0,1,0-.592-.177l-.51,1.7-.491-.82a.309.309,0,0,0-.53,0l-.491.82-.51-1.7a.309.309,0,1,0-.592.177l.711,2.373A.309.309,0,0,0,183.517,156.432Z",
    transform: "translate(-178.381 -153.443)",
    fill: "#324655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.894,153.451a.309.309,0,0,0-.385.207l-.51,1.7-.491-.82a.309.309,0,0,0-.53,0l-.491.82-.51-1.7a.309.309,0,1,0-.592.177l.711,2.373a.309.309,0,0,0,.561.07l.586-.979.586.979a.309.309,0,0,0,.265.15l.038,0a.309.309,0,0,0,.258-.218l.711-2.373A.309.309,0,0,0,286.894,153.451Z",
    transform: "translate(-275.062 -153.438)",
    fill: "#324655"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWww, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/www.445d1ae1.svg";
export { ForwardRef as ReactComponent };